/* 遊戲頁（game.html） */
import '../core/index.ts';
import '../render/stage.ts';
import '../render/itemicons.ts';
import '../render/view.ts';
import '../render/elfx.ts';
import '../render/herofx.ts';
import '../render/skinfx.ts';
import '../game/audio.ts';
import '../game/meta.ts';
import '../game/share.ts';
import '../campaign/index.ts';
import '../game/game.ts';
import '../game/account.ts';
import '../game/cloud.ts';
import '../game/home.ts';
import '../net/net.ts';
import '../net/social.ts';
import '../game/dm.ts';

// 加到主畫面（PWA）：註冊 Service Worker（網路優先、離線時用快取）；自動化測試的瀏覽器不註冊，免得快取干擾
if ('serviceWorker' in navigator && !navigator.webdriver && (location.protocol === 'https:' || location.hostname === 'localhost')) {
  window.addEventListener('load', () => { navigator.serviceWorker.register('sw.js').catch(() => {}); });
}
